import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import edit from './edit';
import save from './save';
import RelatedPostsBlockData from './block.json';
import attributeVisibility from '@components/visibility/attributes.json';
import { getBlockLabelByName } from '@helpers/utils';
import relatedPostsIcon from './icons';

const { name, ...settings } = RelatedPostsBlockData;
const attributes = {
  ...attributeVisibility,
  ...settings.attributes,
};

registerBlockType(name, {
  ...settings,
  icon: relatedPostsIcon,
  attributes,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
